"use strict";
// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatU8A = exports.bytes32ToCid = exports.cidToBytes32 = exports.isCID = exports.CIDv1 = exports.CIDv0 = void 0;
const ethers_1 = require("ethers");
const buffer_1 = __importDefault(require("buffer"));
const Buffer = buffer_1.default.Buffer;
exports.CIDv0 = new RegExp(/Qm[1-9A-HJ-NP-Za-km-z]{44}/i);
exports.CIDv1 = new RegExp(/Qm[1-9A-HJ-NP-Za-km-z]{44,}|b[A-Za-z2-7]{58,}|B[A-Z2-7]{58,}|z[1-9A-HJ-NP-Za-km-z]{48,}|F[0-9A-F]{50,}/i);
function isCID(cid) {
    return exports.CIDv0.test(cid) || exports.CIDv1.test(cid);
}
exports.isCID = isCID;
function cidToBytes32(cid) {
    return `0x${Buffer.from(ethers_1.utils.base58.decode(cid)).slice(2).toString('hex')}`;
}
exports.cidToBytes32 = cidToBytes32;
function bytes32ToCid(bytes) {
    // Add our default ipfs values for first 2 bytes:
    // function:0x12=sha2, size:0x20=256 bits
    // and cut off leading "0x"
    const hashHex = `1220${bytes.slice(2)}`;
    const hashBytes = Buffer.from(hashHex, 'hex');
    return ethers_1.utils.base58.encode(hashBytes);
}
exports.bytes32ToCid = bytes32ToCid;
function concatU8A(a, b) {
    const res = new Uint8Array(a.length + b.length);
    res.set(a, 0);
    res.set(b, a.length);
    return res;
}
exports.concatU8A = concatU8A;
//# sourceMappingURL=ipfs.js.map